<template>
  <div class="layout-column">
    <div class="flex-gt-sm-100 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.description'"
                           :ref="path + '.description'"
                           rules="min:2|trim_string"
                           v-slot="{ errors }">
        <long-input
          inputType="textArea"
          :color="compColor.textInput"
          :name="path + '.description'"
          :label="$t('FORMS_DIVERSE.ANNOTATION_HEADER')"
          v-model="model.description"
          :disabled="isDisabled"
          :dense="isDense || denseFields"
          :error="errors[0]"
        ></long-input>
      </validation-provider>
    </div>
  </div>
</template>

<script>
export default {
  name: "Anmerkung",
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    isDense: {
      type: Boolean
    }
  },
  data () {
    return {
      model: {}
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
